PJQ.views.timecards.LineItemsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-line-items'),
        onLineItemChanged: null,
        canEdit: true
    },
    events: {
        'keyup .li-overtime-hours, .li-regular-hours, .li-doubletime-hours': 'lineItemHoursChanged',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-delete-line-item': 'deleteLineItem',
        'click .btn-view-li-locations': 'viewTimecardLocationsClicked'
    },
    beforeFirstRender: function () {
        this.model = this.options.model;
        this.contact = null;

        let fnFetch = () => {
            if (this.options.project != null) {
                this.options.project.fetchPermissions((perms) => {
                    this.options.permissions = perms;
                    if (this.options.settings.get('enableLineItems')) {
                        this.options.project.fetchSubJobs((subJobs) => {
                            this.subJobs = subJobs;
                            this.options.project.fetchCostCodes((costCodes) => {
                                this.costCodes = costCodes;
                                this.isFetched = true;
                                this.render();
                            });
                        });
                    } else {
                        this.isFetched = true;
                        this.render();
                    }
                });
            } else {
                this.options.permissions = PJQ.app.session.systemPermissions;
                this.isFetched = true;
            }
        };
        this.isFetched = false;
        fnFetch();
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canEdit = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.enableOvertime = this.options.settings.get('enableOvertime');
            this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
            this.options.enableClockIn = this.options.settings.get('enableClockIn')
        }
    },
    renderData: function () {
        return {
            model: this.model,
            contact: this.contact,
            project: this.options.project,
            canEdit: this.options.canEdit,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderLineItems();
    },
    renderLineItems: function () {
        if (this.options.canEdit && _.size(this.model.lineItems.models) === 0) {
            this.model.lineItems.add(this.newLineItem());
        }

        let columns = [
            {
                "title": "#",
                "width": "50px",
                "render": _.bind(function (data, type, row, opt) {
                    let icons = '';
                    if ((row.get('latitudeIn') && row.get('longitudeIn')) || (row.get('latitudeOut') && row.get('longitudeOut'))) {
                        icons += '<button type="button" title="View Time Card Locations" class="btn btn-link btn-view-li-locations fs-16 ml-1"><i class="fal fa-location-dot"></i></button>'
                    }
                    return '<div class=" text-align-center ' + (this.options.canEdit ? '' : 'p-1') + '">' + (opt.row + 1).toString() + icons + '</div>';
                }, this)
            },
            {
                "title": "Sub Job",
                "width": "150px",
                "visible": this.subJobs != null && _.size(this.subJobs.models) > 0,
                "render": (data, type, row) => {
                    if (this.options.canEdit && row.isNew()) {
                        return '<select class="select-sub-job form-control"></select>';
                    }

                    let costCode = this.costCodes.get(row.get('costCodeId')),
                        subJob = this.subJobs.get(costCode.get('subJobId'));
                    return subJob ? subJob.get('name') : '';
                }
            },
            {
                "title": "Cost Code",
                "width": "250px",
                "render": (data, type, row) => {
                    if (this.options.canEdit && row.isNew()) {
                        return '<select class="select-cost-code form-control"></select>';
                    }

                    let costCode = this.costCodes.get(row.get('costCodeId'));
                    return costCode ? costCode.getDisplayName() : '';
                }
            }];

        if (this.options.enableClockIn) {
            columns.push(...[{
                "data": "attributes.timeIn",
                "width": "150px",
                "title": "Time In",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": _.bind(function (data, type, row) {
                    let time = '';
                    if (data != null) {
                        time = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME)
                    }
                    if (this.options.canEdit) {
                        return '<div class="position-relative input-group"><input type="text" class="form-control input-time li-time-in" data-cid="' + row.cid +'" placeholder="12:00 AM" value="' + time + '"></div>';
                    }
                    return time;
                }, this),
            },
                {
                    "data": "attributes.timeOut",
                    "width": "150px",
                    "title": "Time Out",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let time = '';
                        if (data != null) {
                            time = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME)
                        }
                        if (this.options.canEdit) {
                            return '<div class="position-relative input-group"><input type="text" class="form-control input-time li-time-out" data-cid="' + row.cid +'" placeholder="12:00 AM" value="' + time + '"></div>';
                        }
                        return time;
                    }, this),
                }]);
        } else {
            columns.push(...[
                {
                    "data": "attributes.regularHours",
                    "width": "120px",
                    "title": this.options.enableOvertime || this.options.enableDoubletime ? "Regular" : "Hours",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('regularHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-regular-hours" value="' + hrs + '" data-type="regularHours" placeholder="0">';
                        }
                        return hrs;
                    }, this),
                },
                {
                    "data": "attributes.overtimeHours",
                    "width": "120px",
                    "title": "Overtime",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "visible": this.options.enableOvertime === true,
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('overtimeHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-overtime-hours" value="' + hrs + '" data-type="overtimeHours" placeholder="0">';
                        }
                        return hrs;
                    }, this),
                },
                {
                    "data": "attributes.doubletimeHours",
                    "width": "120px",
                    "title": "Double Time",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "visible": this.options.enableDoubletime === true,
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('doubletimeHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-doubletime-hours" value="' + hrs + '" data-type="doubletimeHours" placeholder="0">';
                        }
                        return hrs;
                    }, this),
                }]);
        }

        if (this.options.canEdit) {
            columns.push({
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                width: 50,
                className: 'text-align-center',
                render: _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button></div>';
                }, this)
            });
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.line-items-table'),
            data: _.filter(this.model.lineItems.models, function (lineItem) {
                return !lineItem.get('delete');
            }),
            autoWidth: false,
            fixedHeader: {
                header: false,
                footer: false
            },
            isHideSearch: true,
            paging: false,
            order: [1, 'asc'],
            language: {
                emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            },
            columns: columns,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteLineItem(row);
                        }, this),
                        isShown: _.bind(function (row) {
                            this.options.canEdit
                        }, this),
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));

        if (this.options.canEdit) {
            this.addListeners();
            if (!this.binder) {
                this.binder = new PJQ.Binder(this.$el, this.model.lineItems, {
                    delegate: true,
                    useDecimalPercentFields: true,
                    watchElements: [
                        'input'
                    ]
                });
            }

            _.each(this.model.lineItems.models, function(model){
                model.timeInPicker = new PJQ.inputs.Datepicker({
                    el: this.$('.li-time-in[data-cid="' + model.cid + '"]'),
                    isTimeOnly: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                        defaultDate: model.get('timeIn')
                    },
                    onChange: (value) => {
                        model.set('timeIn', value);
                    }
                });

                model.timeOutPicker = new PJQ.inputs.Datepicker({
                    el: this.$('.li-time-out[data-cid="' + model.cid + '"]'),
                    isTimeOnly: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                        defaultDate: model.get('timeOut')
                    },
                    onChange: (value) => {
                        model.set('timeOut', value);
                    }
                });
            }, this)


            if (this.subJobs != null && _.size(this.subJobs.models) > 0) {
                new PJQ.inputs.SelectPickerCollection(this.$el, this.model.lineItems.models, {
                    pickerSelector: '.select-sub-job',
                    valueAttribute: 'subJobId',
                    selectPickerOptions: {
                        noneSelectedText: 'Parent Job',
                        isLiveSearch: true,
                        isIntChoices: true,
                        size: 8,
                        isDisabled: _.bind(function (model) {
                            return !model.isNew() || !this.options.canEdit;
                        }, this),
                        choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                            name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                                return {
                                    id: subJob.id,
                                    name: subJob.get('code'),
                                    subtext: subJob.get('name')
                                }
                            }, this)
                        }])
                    },
                    onChange: _.bind(function (model, value) {
                        model.set('subJobId', value > 0 ? value : null);
                        model.set('costCodeId', null);

                        let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                        costCodePicker.render();
                    }, this)
                });
            }

            this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.model.lineItems.models, {
                pickerSelector: '.select-cost-code',
                valueAttribute: 'costCodeId',
                selectPickerOptions: {
                    isLiveSearch: true,
                    isIntChoices: true,
                    hideDisabled: false,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit;
                    }, this),
                    choices: (model) => {
                        let sjId = model.get('subJobId');
                        return _.map(_.filter(this.costCodes.models, (costCode) => {
                            return (sjId == null && costCode.get('subJobId') == null) || costCode.get('subJobId') === sjId;
                        }).sort((c1, c2) => {
                            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
                        }), function (costCode) {
                            return {
                                id: costCode.id,
                                name: costCode.getDisplayName()
                            };
                        });
                    }
                },
                onChange: _.bind(function (model, value) {
                    model.set('costCodeId', value);
                }, this)
            });
        }
    },
    addListeners: function () {
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'change', (lineItem) => {
            let lineItems = _.filter(this.model.lineItems.models, (lineItem) => {
                return !lineItem.get('delete');
            })
            this.model.set({
                regularHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('regularHours');
                }, 0),
                overtimeHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('overtimeHours');
                }, 0),
                doubletimeHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('doubletimeHours');
                }, 0)
            });
            if (typeof this.options.onLineItemChanged === 'function') {
                this.options.onLineItemChanged(lineItem);
            }
        });
    },
    getLineItemForInput: function ($input) {
        if ($input == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow($input.closest('tr'));
        if (row) {
            return row.data();
        }
        return null;
    },
    getLineItemElement: function (lineItem) {
        if (lineItem == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow(lineItem.cid);
        if (row) {
            return $(row.node());
        }
        return null;
    },
    lineItemHoursChanged: function (e) {
        let lineItem = this.getLineItemForInput($(e.currentTarget)),
            type = $(e.currentTarget).data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($(e.currentTarget).val());
        lineItem.set(type, minutes);
    },
    addLineItem: function (e) {
        this.model.lineItems.add(this.newLineItem());
        this.renderLineItems();
    },
    newLineItem: function () {
        return new PJQ.models.timecards.TimeCardLineItem({
            timeCardId: this.model.id,
            notes: '',
            regularHours: 0,
            overtimeHours: 0,
            doubletimeHours: 0
        });
    },
    deleteLineItem: function (e) {
        let lineItem = this.getLineItemForInput($(e.currentTarget));
        if (lineItem) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Line Item?",
                onDelete: _.bind(function () {
                    lineItem.set('delete', true);
                    this.renderLineItems();
                }, this)
            });
        }
    },
    viewTimecardLocationsClicked: function (e) {
        let target = $(e.currentTarget),
            lineItem = this.dataTable.getRow(target.closest('tr')).data();

        this.viewTimecardLocations(lineItem);
    },
    viewTimecardLocations: function (lineItem) {
        new PJQ.views.timecards.TimeCardLocationMapModal({
            model: lineItem
        });
    }
});